import React, { useEffect, useState } from "react";
import { Box, Grid, Button, IconButton } from "@mui/material";
import { Search as SearchIcon, Close } from "@mui/icons-material";
import TextField from "../../components/TextField";
import QRCodeScanner from "../../components/QRCodeScannerX";
import CircularLoading from "../../components/CircularLoading";
import Alert from "../../components/ConfirmIconButton";

interface Props {
  activeTab: string;
  onScanned: (decodedText: string, decodedResult: any) => void;
  onScanError: (errMessage: string) => void;
  onCheckinTicket: (ticketNumber: string) => void;
  loading?: boolean;
  loadingLabel: string;
  error: boolean;
  message: string;
  onCancel: () => void;
  cameraOpen: boolean;
  clearInput: boolean;
}

export default function TicketChecking(props: Props) {
  const [state, setState] = useState({
    ticketNumber: "",
  });

  const onInputChange = (value) => {
    setState((prev) => ({ ...prev, ticketNumber: value }));
    if (value.length === 10) {
      props.onCheckinTicket(value);
    }
  };

  useEffect(() => {
    setState((prev) => ({ ...prev, ticketNumber: "" }));
  }, [props.clearInput]);

  return (
    <React.Fragment>
      {props.activeTab === "code" ? (
        <Grid container direction="column" alignItems="center">
          <TextField
            name="TicketNumber"
            label="Ticket Number"
            onChange={(value) => {
              onInputChange(value);
            }}
            fullWidth
            endAndorment={
              <IconButton
                onClick={() => props.onCheckinTicket(state.ticketNumber)}
              >
                <SearchIcon fontSize="medium" />
              </IconButton>
            }
            disabled={props.loading}
            value={state.ticketNumber}
            autoFocus
            clearInput={props.clearInput}
          />
        </Grid>
      ) : (
        <Grid container direction="column" alignItems="center">
          <QRCodeScanner
            open={props.cameraOpen}
            onScanned={props.onScanned}
            onError={props.onScanError}
          />
        </Grid>
      )}
      <Box width="100%">
        {props.message !== "" && (
          <React.Fragment>
            <Alert
              label={props.message}
              type={props.error ? "error" : "success"}
            />
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                startIcon={<Close />}
                variant="outlined"
                onClick={props.onCancel}
              >
                Close
              </Button>
            </Box>
          </React.Fragment>
        )}
        {props.loading && <CircularLoading label={props.loadingLabel} />}
      </Box>
    </React.Fragment>
  );
}
